import React from "react";
import { Icon, Link } from "@bookingcom/bui-react";
import { ArrowNavUpIcon, ArrowNavDownIcon } from "@bookingcom/bui-assets-react/streamline";
import Frame from "../Frame/index.js";
const SearchFiltersDisplayController = ({ displayedRowsCount, setDisplayedRowsCount, defaultDisplayedRowsCount, allRowsCount, showMoreCopy, showLessCopy }) => {
    if (allRowsCount <= defaultDisplayedRowsCount) {
        return null;
    }
    const showExpand = displayedRowsCount <= defaultDisplayedRowsCount;
    const expandAllFilters = () => {
        setDisplayedRowsCount(allRowsCount);
    };
    const collapseFilters = () => {
        setDisplayedRowsCount(defaultDisplayedRowsCount);
    };
    const onClick = () => {
        showExpand ? expandAllFilters() : collapseFilters();
    };
    const copy = showExpand ? showMoreCopy : showLessCopy;
    const icon = showExpand ? ArrowNavDownIcon : ArrowNavUpIcon;
    return (React.createElement(Link, { onClick: onClick },
        React.createElement(Frame, { direction: "row" },
            copy,
            React.createElement(Frame, { direction: "column", justifyContent: "center" },
                React.createElement(Icon, { svg: icon, size: "small", color: "action" })))));
};
export default SearchFiltersDisplayController;
